import { Component, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AngularMaterialModule } from '../../../material.module';
import { MatDialog } from '@angular/material/dialog';
import { ChangePasswordModalComponent } from '../change-password-modal/change-password-modal.component';
import { AdminProfileModalComponent } from '../admin-profile-modal/admin-profile-modal.component';
import { RouteData } from '@lib/interfaces/route-data.interface';
import { filter } from 'rxjs';
import { Utils } from '@lib/utils';

@Component({
    standalone: true,
    imports: [CommonModule, AngularMaterialModule],
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
    @Output()
    opened: EventEmitter<boolean> = new EventEmitter();

    isOpen = false;
    primary_color = '';
    routeData: RouteData;
    constructor(private router: Router, private dialog: MatDialog, private route: ActivatedRoute, private readonly Utils: Utils) {}

    ngOnInit() {
        this.routeData = this.Utils.getRouteData(this.route);
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
            this.routeData = this.Utils.getRouteData(this.route);
        });
    }

    isRouteMatch(route: string): boolean {
        if (this.router.url === route) return true;

        return false;
    }

    toggleDropdown(): void {
        this.isOpen = !this.isOpen;
    }

    logout(): void {
        const tenantKey = localStorage.getItem('tenantKey') || '';
        localStorage.removeItem('accessToken');
        localStorage.removeItem('customToken');
        localStorage.removeItem('permissions');
        localStorage.removeItem('selectedUser');
        localStorage.removeItem('tenantKey');
        localStorage.removeItem('userInfo');
        localStorage.removeItem('callCenter');
        localStorage.removeItem('isSubAgent');
        localStorage.removeItem('parentUserId');
        localStorage.removeItem('masterAccount');
        localStorage.removeItem('masterAccountId');
        localStorage.removeItem('cardType');
        this.router.navigate([`/auth/${tenantKey}/login`]);
    }

    openNav() {
        this.opened.emit(true);
    }

    openChangePassword(): void {
        this.dialog.open(ChangePasswordModalComponent, {
            width: '588px',
        });
    }

    viewAdminProfile(): void {
        this.dialog.open(AdminProfileModalComponent, {
            autoFocus: false,
            width: '660px',
        });
    }
}
